module.exports = __webpack_public_path__ + "img/facepaint_jp.ac9a20d.jpg";